<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-md-2 "></div>
            <div class="col-md-10 ">
                <div class="header-block">
                    <h2>Why Choose Anima</h2>
                    <p>
                        Corporate mental health screening generates a 530% ROI, according to Deloitte. Accurate and
                        scientifically validated insights into mental health foster a culture of care, increase employee
                        engagement, and reduce turnover.
                    </p>
                </div>
            </div>
        </div>

        <app-about-us-item-business [item]="item" *ngFor="let item of data"></app-about-us-item-business>

        <!--        <app-achivement></app-achivement>-->

    </div>
</section>
